import { useReducer } from 'react';
import searchReducer from './search/reducer';
import getSearchActions from './search/getActions';
import periodsReducer from './periods/reducer';
import getPeriodsActions from './periods/getActions';
import { ILeaguePeriodFilters } from '@/finsight/application/League/interfaces';

interface IProps {
  ttmFilterInitState: ILeaguePeriodFilters,
  searchText: string,
}

export default ({ searchText, ttmFilterInitState }:IProps) => {
  const [searchState, searchDispatch] = useReducer(searchReducer, { value: searchText });
  const searchActions = getSearchActions(searchState, searchDispatch);

  const [periodsState, periodsDispatch] = useReducer(periodsReducer, ttmFilterInitState);
  const periodsActions = getPeriodsActions(periodsState, periodsDispatch);

  return {
    state: {
      search: searchState,
      periods: periodsState,
    },
    ...searchActions,
    ...periodsActions,
  };
};
